// all possible template translation keys
export const templateTranslationKeys = [
  'cover.title',
  'cover.body',
  'slide.title',
  'column.title',
  'slide.body',
  'column.body',
  'image.caption',
  'quiz.title',
  'openQuestion.title',
  'poll.title',
  'wordCloud.title',
  'fillInTheBlanks.title',
  'fillInTheBlanks.body',
  'answerByCategory.title',
  'answerByCategory.category1',
  'answerByCategory.category2',
  'sortingQuestion.title',
  'dragAndDrop.title',
] as const;

export type TemplateTranslationKey = (typeof templateTranslationKeys)[number];

export type TemplateTranslationDict = Record<TemplateTranslationKey, string>;

/** We need to make sure we always have something, Storybook for instance relies on it */
export const fallbackCopy: TemplateTranslationDict = {
  'cover.title': 'Lesson title',
  'cover.body': 'Learning objective',
  'slide.title': 'Slide heading',
  'column.title': 'Column heading',
  'slide.body': 'Slide text',
  'column.body': 'Column text',
  'image.caption': 'Image caption',
  'quiz.title': 'Enter your question here',
  'openQuestion.title': 'Enter your question here',
  'poll.title': 'Enter your question here',
  'wordCloud.title': 'Question or subject',
  'fillInTheBlanks.title': 'Question or subject',
  'fillInTheBlanks.body': 'Add your content here, select the text and make it a fill in the blanks word',
  'answerByCategory.title': 'Question or subject',
  'answerByCategory.category1': 'Category 1',
  'answerByCategory.category2': 'Category 2',
  'sortingQuestion.title': 'Enter your question here',
  'dragAndDrop.title': 'Enter your question here',
};
